<template>
    <div class="test__wrapper" v-if="url">
        Для заполнения анкеты перейдите по
        <a :href="url" target="__blank">ссылке</a>
    </div>
    <div class="test__wrapper" v-else-if="url === false">
        Анкета не найдена
    </div>
</template>

<script>
let fromObject = {};

export default {
    name: 'MentoringSurveyStart',

    data: () => ({
        url: null,
    }),

    async mounted() {
        this.$mainMixinScrollUp();
        let url = new URL(`https://${window.rsvDomain}${fromObject.path}`);
        this.$store.getters['isMobileApp'] && url.searchParams.set('is_mobile_app', 'true');
        this.url =
            (await this.$store.dispatch('startSurvey', {
                surveyId: this.$route.params.id,
                singleResult: false,
                returnUrl: url.toString(),
                mentoringRole: this.$route.query.mentoringRole,
            })) || false;
        if (this.url) {
            window.location = this.url;
        }
    },
    beforeRouteEnter(to, from, next) {
        fromObject = from;
        next();
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/rem';

.test__wrapper {
    margin-top: rem(40);
    text-align: center;

    &,
    & > * {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: rem(32);
        line-height: rem(39);
        color: #2a2626;
    }

    a {
        color: #4663AB;
    }
}
</style>
